<div class="card step mr-auto ml-auto">
  <div class="card-header step-header" id="optionStep">
    <div class="col-12">
      <div class="d-flex flex-row justify-content-between align-content-center col-12">
        <span class="d-flex align-items-center">
          <span *ngIf="confirmedOption &&  !editModeOn"
                class="icon-circle d-flex align-items-center justify-content-center  mr-2">
            <i class="fas fa-check"></i>
          </span>
          <span><strong>2. {{translatePath + 'shipping-options' | translate}}</strong></span>
        </span>
        <div class="d-flex">
          <button (click)="setEditModeState(true)" *ngIf="confirmedOption && !editModeOn"
                  class="btn btn-outline-info d-flex align-items-center justify-content-center"
                  type="button">
            <span>
              {{'buttons.edit' | translate}}
            </span>
          </button>
          <button (click)="setEditModeState(false)" *ngIf="confirmedOption && editModeOn"
                  class="btn btn-outline-info d-flex justify-content-center align-items-center align-self-end"
                  type="button">
            <span>
              {{'buttons.cancel-edit' | translate}}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div #optionStepId="ngbCollapse" [(ngbCollapse)]="!expanded">
    <div class="card-body">
      <div *ngIf="confirmedOption && !editModeOn" class="d-flex flex-column col-12">
        <h6 class="col-12 btn text-left mb-0 pb-0">{{translatePath + 'delivery-method' | translate}}</h6>
        <div class="col-12">
          <hr class="border-grey w-auto my-2">
        </div>
        <div class="d-flex flex-column col-12">
          <app-address-block
            *ngIf="confirmedOption.addressOfDepartment && (confirmedOption.direction == directionEnum.AddressToDepartment || confirmedOption.direction == directionEnum[directionEnum.AddressToDepartment])"
            [address]="confirmedOption.addressOfDepartment">
          </app-address-block>
          <span *ngIf="confirmedOption?.carrier?.carrierName"
                class="mt-2">
                        {{'admin.table.carrier' | translate}} - {{confirmedOption?.carrier?.carrierName}}
                    </span>
          <span
            *ngIf="confirmedOption.cost">{{'public.order-confirmation.arrives-between' | translate}} {{(confirmedOption.estimatedOnEnd | dateTranslate : 'fullDate')}}</span>
          <span *ngIf="confirmedOption.cost"><strong>{{confirmedOption.cost + ' MDL'}}</strong></span>
          <div class="alert alert-warning mt-3" *ngIf="internationalShipping">
            {{'public.shipping-details.labels.estimated-delivery-date-warning' |translate}}
          </div>
        </div>
      </div>
      <div class="col-12">
        <div *ngIf="editModeOn" class="d-flex flex-column col-12">
          <h6>{{translatePath + 'delivery-method' |translate}}</h6>
          <div>
            <hr class="border-grey w-auto my-2">
          </div>
          <div class="widget-top-search  px-0 col-12 mt-2">
            <div *ngIf="directions.length > 0" class="row">
              <div class="col-6  search-container d-flex flex-row">
                <input (keyup)="applyFilter($event)" class="form-control" id="inputTopSearch"
                       placeholder="{{translatePath+'search' | translate}}" type="search"
                       value=""/>
              </div>
              <div class="col-6">
                <div class="form-group d-flex flex-row align-content-center justify-content-center">
                  <label class="select col-3 align-self-center pl-0"></label>
                  <select (change)="sort($event)" class="form-control col-9">
                    <option [selected]="true" class="option" disabled>{{translatePath + 'sort' | translate}}</option>
                    <option selected value='deliveryCostLH'>
                      {{translatePath + 'sorting-options.delivery-cost-low-high' | translate}}
                    </option>
                    <option selected value='deliveryCostHL'>
                      {{translatePath + 'sorting-options.delivery-cost-high-low' | translate}}
                    </option>
                    <option selected value='companyAZ'>
                      {{translatePath + 'sorting-options.company-a-z' | translate}}
                    </option>
                    <option selected value='companyZA'>
                      {{translatePath + 'sorting-options.company-z-a' | translate}}
                    </option>
                    <option selected value='deliverytimeHL'>
                      {{translatePath + 'sorting-options.delivery-time-slow-quick' | translate}}
                    </option>
                    <option selected value='deliverytimeLH'>
                      {{translatePath + 'sorting-options.delivery-time-quick-slow' | translate}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="alert alert-warning" role="alert">
                {{translatePath + 'delivery-estimated-date-warning' |translate}}
              </div>
            </div>
          </div>

          <div class="widget-tabs">
            <div class="row">
              <div class="col-12 ">
                <ul *ngIf="directions.length > 0" class="nav nav-tabs" id="tabs" role="tablist">
                  <li class="nav-item col-6">
                    <a class="nav-link active d-flex justify-content-center" data-toggle="tab" href="#pane-A" id="tab-A"
                       role="tab">
                      <span>
                        {{translatePath + 'home-delivery' | translate}}
                      </span>
                    </a>
                  </li>
                  <!--<li class="nav-item col-6">
                      <a id="tab-B" href="#pane-B" class="nav-link d-flex justify-content-center" data-toggle="tab"
                         role="tab">
                          <span>
                              {{translatePath+'pick-up' | translate}}
                          </span>
                      </a>
                  </li>-->
                </ul>
                <div class="tab-content" id="content" role="tablist">
                  <div aria-labelledby="tab-A" class="tab-pane fade show active" id="pane-A" role="tabpanel">
                    <div class="widget-cards card-services ">
                      <div class="col-12">
                        <table class="table">
                          <tbody>
                          <div *ngFor="let item of filterNormalizedOptions; let i = index"
                               class=" d-flex flex-column align-content-center w-100">
                            <tr
                              *ngIf="(item.direction == directionEnum.AddressToAddress || item.direction == directionEnum[directionEnum.AddressToAddress]) && item.cost > 1"
                              class=" d-flex flex-row align-content-center w-100">
                              <td class="col-1 d-flex flex-column justify-content-center">
                                <div *ngIf="item.succeeded">
                                  <input (click)="selectedChanged(item)" [checked]="inputChecked(item)"
                                         class="form-check-input" id="{{'homeDeliveryRadios' + i}}"
                                         name="homeDeliveryRadios"
                                         type="radio" value="{{item.cost}}">
                                  <label class="form-check-label align-self-center h-50"
                                         for="{{'homeDeliveryRadios'+i}}">
                                    <!-- {{createOptionText(item)}} -->
                                  </label>
                                </div>
                                <div *ngIf="!item.succeeded">
                                  <input (click)="false;" [checked]="false" class="form-check-input"
                                         id="{{'homeDeliveryRadios'+i}}" name="homeDeliveryRadios" readonly="readonly"
                                         type="radio" value="{{item.cost}}">
                                  <label class="form-check-label align-self-center h-50"
                                         for="{{'homeDeliveryRadios'+i}}">
                                    <!-- {{createOptionText(item)}} -->
                                  </label>
                                </div>
                              </td>
                              <td class="col-5">
                                <div class="d-flex flex-row align-content-center">
                                  <div class="image-box align-items-center text-center">
                                    <img *ngIf="item.carrier.logo" [src]="createLogoBase64Url(item.carrier.logo)"
                                         class="img-fluid image-container">
                                  </div>
                                  {{getErrorCarriers(item)}}
                                  <div class="carrier d-flex flex-column ml-2">
                                    <label class="d-flex flex-column">
                                      <span>
                                        {{item.carrier.carrierName}}
                                      </span>
                                      <small>
                                        <a [href]="item.carrier.webUrl" target="blank">
                                          {{item.carrier.webUrl | truncate:[16]}}
                                        </a>
                                      </small>
                                    </label>
                                  </div>
                                </div>
                              </td>
                              <td class="express-delivery">
                                <div
                                  *ngIf="item.deliveryType.includes('Express') && !item.deliveryType.includes('Standard') && !internationalShipping"
                                  class="d-flex align-items-center h-100">
                                  <span
                                    ngbTooltip="{{ translatePath + 'tooltip' | translate }}">
                                    <i class='fas fa-shipping-fast'></i>
                                  </span>
                                </div>
                                <div
                                  *ngIf="item.deliveryType.includes('PostaMoldoveiInternationalEMS') && internationalShipping"
                                  class="d-flex align-items-center h-100">
                                  <span
                                    ngbTooltip="{{ translatePath + 'tooltip' | translate }}">
                                    <i class='fas fa-plane'></i>
                                  </span>
                                </div>
                              </td>
                              <td class="col-md-4 col-sm-3 d-flex flex-column justify-content-center">
                                <span class="delivery">
                                  {{translatePath + 'arrives-by' |translate}}
                                  {{item.estimatedOnEnd | dateTranslate : 'fullDate'}}
                                </span>
                              </td>
                              <td class="col-2 d-flex flex-column justify-content-center">
                                <span>
                                  {{item.cost}} MDL
                                </span>
                              </td>

                              <!--                              <td class="col-1 d-flex justify-content-center align-items-center">-->
                              <!--                                <span *ngIf="item.deliveryType.includes('Express') && !item.deliveryType.includes('Standard')">{{translatePath + 'tooltip' | translate}}</span>-->
                              <!--                              </td>-->
                              <!--                              <td class="col-1 express-delivery">-->
                              <!--                                <div *ngIf="item.deliveryType.includes('Express') && !item.deliveryType.includes('Standard')" class="d-flex align-items-center h-100">-->
                              <!--&lt;!&ndash;                                  <span&ndash;&gt;-->
                              <!--&lt;!&ndash;                                    ngbTooltip="{{ translatePath + 'tooltip' | translate }}">&ndash;&gt;-->
                              <!--&lt;!&ndash;                                    <i class='fas fa-shipping-fast'></i>&ndash;&gt;-->
                              <!--&lt;!&ndash;                                  </span>&ndash;&gt;-->
                              <!--                                  <span>{{translatePath + 'tooltip' | translate}}</span>-->
                              <!--                                </div>-->
                              <!--                              </td>-->
                            </tr>
                          </div>
                          <div *ngIf="directions.length == 0"
                               class="no-carriers d-flex flex-column align-items-center justify-content-center">
                            <div class="icon"><i class="bi bi-exclamation-circle"></i></div>
                            <p class="prg">{{'Din păcate, la moment nu sunt curieri disponibili' | translate}}</p>
                          </div>
                          </tbody>
                        </table>
                        <p *ngIf="errorCarriers !== ''"
                           class="alert-info">{{translatePath + 'unavailableCarrierDisclaimer' |translate}} {{errorCarriers}}</p>
                      </div>
                    </div>
                  </div>
                  <div aria-labelledby="tab-B" class="tab-pane fade" id="pane-B" role="tabpanel">
                    <div class="widget-cards card-services ">
                      <div class="col-12">
                        <table class="table">
                          <tbody>
                          <div *ngFor="let item of filterNormalizedOptions; let i = index"
                               class=" d-flex flex-column align-content-center w-100">
                            <tr
                              *ngIf="item.direction == directionEnum.AddressToDepartment || item.direction == directionEnum[directionEnum.AddressToDepartment]"
                              class=" d-flex flex-row align-content-center w-100">
                              <td class="col-1 d-flex flex-column justify-content-center">
                                <div class="">
                                  <input (click)="selectedChanged(item)" [checked]="inputChecked(item)"
                                         class="form-check-input" id="{{'officeDeliveryRadios'+i}}"
                                         name="officeDeliveryRadios"
                                         type="radio" value="{{item.cost}}">
                                  <label class="form-check-label align-self-center h-50"
                                         for="{{'officeDeliveryRadios'+i}}">
                                  </label>
                                </div>
                              </td>
                              <td class="col-5 ">
                                <div class="d-flex flex-row align-content-center">
                                  <div class="d-flex flex-column ml-1">
                                    <label class="d-flex flex-column">
                                      <span class="delivery">
                                        {{item.carrier.carrierName}}
                                      </span>
                                      <small class="delivery">
                                        <span>{{getAddressText(item)}}</span>
                                      </small>
                                    </label>
                                  </div>
                                </div>
                              </td>
                              <td class="col-4 d-flex flex-column justify-content-center">
                                <span class="delivery">
                                  {{translatePath + 'arrives-by' |translate}}
                                  {{item.estimatedOnEnd | dateTranslate : 'fullDate'}}
                                </span>
                              </td>
                              <td class="col-2 d-flex flex-column justify-content-center">
                                <span>
                                  {{item.cost}} MDL
                                </span>
                              </td>
                            </tr>
                          </div>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sm buttons d-flex w-100 justify-content-end">

              <button (click)="cancel()" *ngIf="returUrl"
                      class="btn btn-outline-info mr-5" type="button">
                        <span>
                            {{'buttons.cancel' | translate}}
                        </span>
              </button>
              <button (click)="confirmOption()" [disabled]="option==null"
                      class="h-auto btn btn-primary btn-sm text-capitalize"
                      type="button">
                        <span>
                            {{'buttons.confirm' | translate}}
                        </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
